<template>
  <b-table
    class="products-table"
    :data="products"
    sticky-header
    selectable
    hoverable
    narrowed
    :height="tableHeight"
  >
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <b-table-column
      field="b"
      :label="$t('vending.barcode')"
      sortable
      v-slot="props"
    >
      {{ props.row.b }}
    </b-table-column>

    <b-table-column
      field="n"
      :label="$t('vending.name')"
      sortable
      v-slot="props"
    >
      {{ props.row.n }}

      <span
        class="is-pulled-right"
        style="z-index: 99999"
        v-if="!vending.vendingInfo.isCacauShow"
      >
        <b-tooltip :label="$t('vending.changeCategory')" position="is-left">
          <b-button
            class="button is-small"
            @click="changeVendingProductCategory(props.row)"
          >
            <b-icon icon="tag"></b-icon>
          </b-button>
        </b-tooltip>
        &nbsp;

        <b-tooltip :label="$t('vending.deleteProduct')" position="is-left">
          <b-button
            class="button is-small"
            @click="removeVendingProduct(props.row.b)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </b-tooltip>
      </span>
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>

    <b-modal :active.sync="changeVendingProductCategoryModalVisible">
      <change-vending-product-category-modal
        :eligibleCategories="eligibleCategories"
        :product="product"
        :vending="vending"
        @update-vending="$emit('update-vending')"
      />
    </b-modal>
  </b-table>
</template>

<script>
import { common } from "../../mixins/common";
import tableEmptyTemplate from "../common/TableEmptyTemplate";
import changeVendingProductCategoryModal from "./ChangeVendingProductCategoryModal";

export default {
  props: ["products", "vending", "categoryId"],

  mixins: [common],

  components: {
    changeVendingProductCategoryModal,
    tableEmptyTemplate
  },

  data() {
    return {
      isLoading: false,
      changeVendingProductCategoryModalVisible: false,
      eligibleCategories: [],
      product: {}
    };
  },

  methods: {
    removeVendingProduct(barcode) {
      this.$buefy.dialog.confirm({
        title: this.$t("vending.removeProductTitle"),
        message: this.$t("vending.removeProductMessage"),
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.cancel"),
        type: "is-primary",
        onConfirm: () => {
          this.isLoading = true;
          this.$store
            .dispatch("removeVendingProduct", {
              barcode,
              vendingId: this.vending._id,
              categoryId: this.categoryId
            })
            .then(res => {
              if (res.data.result === "error") {
                this.alertError(res.data);
              } else {
                this.$buefy.toast.open({
                  message: this.$t("vending.productDeleted"),
                  type: "is-success",
                  position: "is-bottom",
                  duration: 3000
                });
                this.$emit("update-vending");
              }
            })
            .catch(err => {
              this.alertError(err);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },

    changeVendingProductCategory(product) {
      this.eligibleCategories = this.vending.catalog.filter(c => {
        return c._id.toString() !== product.vc.toString();
      });
      this.product = product;
      this.changeVendingProductCategoryModalVisible = true;
    }
  },

  computed: {
    tableHeight() {
      return 5 + this.products.length * 5 + "vh";
    }
  }
};
</script>

<style scoped>
.products-table {
  margin-top: 1rem;
}

.dropdown-menu {
  z-index: 99999;
}
</style>
